import { memo, useMemo } from "react";
import type { RemixiconComponentType } from "@remixicon/react";
import * as IconComponents from "@remixicon/react";

import type { IIconCoreProps } from "@components/icon/type";

export const IconCore = memo(function Icon({
  iconName,
  ...restProps
}: IIconCoreProps) {
  const Icon: RemixiconComponentType = useMemo(
    () => IconComponents[`Ri${iconName}`],
    [iconName],
  );

  return <Icon {...restProps} />;
});
